// extracted by mini-css-extract-plugin
export default {"MainContainer":"Main_MainContainer__BD3lU"};